import { DatabaseFilled } from "@ant-design/icons";
import axios from "../../axiosConfig/axios";
import qs from 'qs'
export const NotificationApis = {
    getUserNotification(token) {
        return axios.get(`/notifications`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
    },
    deleteUserNotification(data,token) {
        console.log(data)
        console.log(token)
        return axios.delete(`/notifications`,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            data: {
                notificationId: data?.type == 'all'? undefined :data?.id
            }
            })
    },
    readUserNotification(data,token) {
        axios.patch(`/notifications`,
            {
                notificationId: [data]
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
    }


}